import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import type { Location } from "react-router-dom";

import { ADMIN_ROLES } from "~/api/admins";
import { Layout } from "~/layout";
import {
  BloodGlucoseDetail,
  BloodOxygenSaturationDetail,
  BloodPressureDetail,
  BodyTemperatureDetail,
  BodyWeightDetail,
  Dashboard,
  FileManager,
  FirmwareDetail,
  Firmwares,
  HeartRateDetail,
  Insoles,
  Login,
  PatientDetail,
  Patients,
  RegularAdmins,
  StepsDetail,
  UnitDetail,
  Units,
} from "~/screens";
import { useUserStore } from "~/stores";
import { ModalRouter } from "./ModalRouter";
import { ROUTES } from "./routes";

export const Router = () => {
  const location = useLocation();
  const { previousLocation } = (location.state ?? {}) as {
    previousLocation?: Location;
  };

  const userRole = useUserStore((state) => state.admin?.role);
  const userState = useUserStore((state) =>
    state.accessToken ? "loggedIn" : "loggedOut",
  );

  const toggleDashboardAndAdmin = false;

  return (
    <>
      <Routes location={previousLocation ?? location}>
        {/* PUBLIC ONLY ROUTES */}
        {userState === "loggedOut" && (
          <>
            <Route
              element={<Navigate to={ROUTES.login} replace />}
              path={"*"}
            />
            <Route element={<Login />} path={ROUTES.login} />
          </>
        )}
        {/* PRIVATE ONLY ROUTES */}
        {userState === "loggedIn" && userRole && (
          <>
            <Route element={<Navigate to={ROUTES.patients} />} path={"*"} />
            <Route element={<Layout />}>
              {/* ROUTES FOR ALL ADMINS */}
              {toggleDashboardAndAdmin && (
                <Route element={<Dashboard />} path={ROUTES.dashboard} />
              )}
              <Route element={<Insoles />} path={ROUTES.insoles} />
              {/* ROUTES FOR REGULAR AND SUPER ADMINS */}
              {(userRole === ADMIN_ROLES.SUPER_ADMINISTRATOR ||
                userRole === ADMIN_ROLES.REGULAR_ADMINISTRATOR) && (
                <>
                  <Route element={<Units />} path={ROUTES.units} />
                  <Route element={<UnitDetail />} path={ROUTES.unitDetail} />
                  <Route element={<Patients />} path={ROUTES.patients} />
                  <Route
                    element={<PatientDetail />}
                    path={ROUTES.patientDetail}
                  />
                  <Route
                    element={<HeartRateDetail />}
                    path={ROUTES.heartRateDetail}
                  />
                  <Route
                    element={<BodyWeightDetail />}
                    path={ROUTES.bodyWeightDetail}
                  />
                  <Route
                    element={<BloodOxygenSaturationDetail />}
                    path={ROUTES.bloodOxygenSaturationDetail}
                  />
                  <Route
                    element={<BodyTemperatureDetail />}
                    path={ROUTES.bodyTemperatureDetail}
                  />
                  <Route element={<StepsDetail />} path={ROUTES.stepsDetail} />
                  <Route
                    element={<BloodGlucoseDetail />}
                    path={ROUTES.bloodGlucoseDetail}
                  />
                  <Route
                    element={<BloodPressureDetail />}
                    path={ROUTES.bloodPressureDetail}
                  />
                  <Route element={<FileManager />} path={ROUTES.fileManager} />
                  <Route element={<Firmwares />} path={ROUTES.firmwares} />
                  <Route
                    element={<FirmwareDetail />}
                    path={ROUTES.firmwaresDetail}
                  />
                </>
              )}
              {/* ROUTES FOR SUPER ADMINS */}
              {userRole === ADMIN_ROLES.SUPER_ADMINISTRATOR &&
                toggleDashboardAndAdmin && (
                  <Route
                    element={<RegularAdmins />}
                    path={ROUTES.regularAdmins}
                  />
                )}
            </Route>
          </>
        )}
      </Routes>
      <Routes>
        <Route
          path="*"
          element={<ModalRouter showModal={!!previousLocation} />}
        />
      </Routes>
    </>
  );
};
